import { Controller } from "../vendor/stimulus.js";

export default class extends Controller {
  static targets = ["form", "optionsContainer", "option", "submitButton"];

  connect() {
    this.selectedOptions = new Set();
    this.updateSubmitState();
  }

  showOptions() {
    this.optionsContainerTarget.classList.add("show-options");
    this.revealScrollArrowsAfterAnimation();
  }

  toggleOption(event) {
    const checkbox = event.target;
    const optionLabel = checkbox.closest(".option");

    if (checkbox.checked) {
      this.selectedOptions.add(checkbox.value);
      optionLabel?.classList.add("selected");
    } else {
      this.selectedOptions.delete(checkbox.value);
      optionLabel?.classList.remove("selected");
    }

    this.updateSubmitState();
  }

  updateSubmitState() {
    if (!this.hasSubmitButtonTarget) return;

    const count = this.selectedOptions.size;

    if (count === 0) {
      this.submitButtonTarget.hidden = true;
    } else {
      this.submitButtonTarget.hidden = false;
      this.submitButtonTarget.textContent = count === 1
        ? "Weiter mit 1 Kategorie"
        : `Weiter mit ${count} Kategorien`;
    }
  }

  async submitForm(event) {
    event.preventDefault();

    if (this.selectedOptions.size === 0) return;

    // Collect form data BEFORE disabling (disabled inputs are excluded from FormData)
    const formData = new FormData(this.formTarget);
    this.disableOptions();

    try {
      const response = await fetch(this.formTarget.action, {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        credentials: "include",
        body: formData,
      });

      if (!response.ok) {
        this.emitGlobalXhrFailed(response.status);
      }
      // Don't process response - SSE handles message rendering
    } catch (error) {
      console.error("OutletMultiselectController submit failed", error);
      this.emitGlobalXhrFailed();
    }
  }

  disableOptions() {
    this.optionTargets.forEach((option) => {
      option.disabled = true;
    });
    this.submitButtonTarget.disabled = true;
  }

  revealScrollArrowsAfterAnimation() {
    if (!this.optionsContainerTarget || this.scrollArrowsShown) return;
    const options = this.optionsContainerTarget.querySelectorAll(".option");
    const lastOption = options.length ? options[options.length - 1] : null;
    if (!lastOption) return;

    const scrollWrapper = this.optionsContainerTarget.closest(".scroll-wrapper");
    if (!scrollWrapper) return;

    const addClass = () => {
      scrollWrapper.classList.add("show-scroll-arrows");
      this.scrollArrowsShown = true;
    };

    const onEnd = () => {
      addClass();
      lastOption.removeEventListener("transitionend", onEnd);
    };

    lastOption.addEventListener("transitionend", onEnd, { once: true });
    window.setTimeout(addClass, 600);
  }

  emitGlobalXhrFailed(status = null) {
    window.dispatchEvent(new CustomEvent("xhr-failed", { detail: { status } }));
  }
}
